import { render, staticRenderFns } from "./modelClue.vue?vue&type=template&id=7136df5e&scoped=true"
import script from "./modelClue.vue?vue&type=script&lang=js"
export * from "./modelClue.vue?vue&type=script&lang=js"
import style0 from "./modelClue.vue?vue&type=style&index=0&id=7136df5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7136df5e",
  null
  
)

export default component.exports